// @flow
import Proposition from 'common/modules/proposition/domain/proposition';
import {
  PROPOSE_SALES_ESTIMATION_SUCCESS,
  SEND_SALES_PROPOSITION,
  SEND_SALES_PROPOSITION_SUCCESS,
  SEND_SALES_PROPOSITION_ERROR,
} from '../actions/salesPropositionActions';
import type { SalesPropositionState } from '../domain/state';

export const INITIAL_STATE = {
  currentProposition: undefined,
  propositions: [],
  currentPage: 1,
  isLastPage: false,
  isFetching: false,
  isFetched: false,
  sending: false,
  error: undefined,
  modify: {
    error: undefined,
  },
};

export default function salesPropositionReducer(state: SalesPropositionState = INITIAL_STATE, action: any): SalesPropositionState {
  switch (action.type) {
    case PROPOSE_SALES_ESTIMATION_SUCCESS:
      return {
        ...state,
        currentProposition: action.proposition,
        isFetched: false,
      };
    case SEND_SALES_PROPOSITION: {
      return {
        ...state,
        sending: true,
        error: undefined,
      };
    }
    case SEND_SALES_PROPOSITION_SUCCESS: {
      return {
        ...state,
        propositions: Proposition.replaceIn(state.propositions, action.proposition),
        currentProposition: state.currentProposition && state.currentProposition.is(action.proposition.reference) ? action.proposition : state.currentProposition,
        sending: false,
      };
    }
    case SEND_SALES_PROPOSITION_ERROR: {
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/reducer/salesPropositionReducer.js